// Module
var code = "<div class=portlet-body collapse=isCollapsed()> <div class=portlet-body-inner ng-transclude></div> </div>";
// Exports
module.exports = code;